import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Menu, Stack } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LanguageIcon from "@mui/icons-material/Language";
import Container from "@mui/material/Container";
import { MenuItem } from "@mui/material";
import strings from "../../assets/string.json";
import "./AppNavMenu.scss";
import useResponsive from "../../hooks/useResponsive";

export default function AppNavMenu({ languageState, setLanguageState }) {
  // const theme = theme();
  const [scrolled, setScrolled] = useState(false);
  const { isMobile } = useResponsive();
  useEffect(() => {
    let frame = 0;
    const handleScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        const next = window.scrollY > 50;
        setScrolled((prev) => (prev === next ? prev : next));
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElLanguage, setAnchorElLanguage] = React.useState(null);

    const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
    };

    const handleOpenLanguageMenu = (event) => {
      setAnchorElLanguage(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
      setAnchorElNav(null);
    };

    const handleCloseLanguageMenu = () => {
      setAnchorElLanguage(null);
    };

    const changeLanguage = (index) => {
      setLanguageState(index);
      handleCloseLanguageMenu();
      localStorage.setItem("language", index);
    };

    const MobileNave = (
      <>
        {isMobile && (
          <>
            <Box sx={{ flexGrow: 1 }}>
              <IconButton onClick={handleOpenNavMenu} aria-label="Open menu">
                <MenuIcon
                  sx={{ color: (theme) => theme.palette.text.primary }}
                />
              </IconButton>
              <Menu
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                MenuListProps={{ component: "nav" }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {strings.menu.appmenu.map((page) => (
                  <MenuItem
                    key={page.id}
                    component="a"
                    href={`#${page.id}`}
                    onClick={handleCloseNavMenu}
                    sx={{ width: 160, justifyContent: "center" }}
                  >
                    <Typography variant="menuText">
                      {page.tag[languageState]}
                    </Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <Stack
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" }, mr: 1 }}
            ></Stack>
          </>
        )}
      </>
    );
    const DesktopNav = (
      <>
        {/* nav items */}
        {!isMobile && (
          <Box className="desktop-nav">
            {strings.menu.appmenu.map((page) => (
              <a key={page.id} className="nav-btn" href={`#${page.id}`}>
                {page.tag[languageState]}
              </a>
            ))}
          </Box>
        )}
      </>
    );
    return (
      <AppBar
        position="fixed"
        id="app-nav"
        sx={{
          backgroundColor: scrolled ? "#0c1428" : "#0a0f1f",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          boxShadow: scrolled ? "0 1px 0 rgba(76,215,246,0.12)" : "none",
          transition: "background-color 0.25s ease",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            className="container"
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {isMobile ? (
              <Stack flexDirection="row" alignItems={"center"}>
                {MobileNave}

                <Stack>
                  <img
                    src="/assets/LOGO.webp"
                    alt="Ahmed Abdalla"
                    className="logo"
                    width="240"
                    height="179"
                    style={{ filter: "invert(100%)" }}
                  />
                </Stack>
              </Stack>
            ) : (
              <>
                <Stack flexDirection="row">
                  <img
                    src="/assets/LOGO.webp"
                    alt="Ahmed Abdalla"
                    className="logo"
                    width="240"
                    height="179"
                    style={{ filter: "invert(100%)" }}
                  />
                </Stack>

                {DesktopNav}
              </>
            )}
            {/* trasnslation */}
            <Stack className="right-side-nave">
              {/* translation icon and menu */}
              <div>
                <Menu
                  anchorEl={anchorElLanguage}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElLanguage)}
                  onClose={handleCloseLanguageMenu}
                >
                  {strings.languages.map((Language, index) => (
                    <MenuItem
                      key={Language}
                      onClick={() => {
                        changeLanguage(index);
                      }}
                      className="language-item"
                    >
                      <img
                        className="flag-image"
                        src={strings.flags[index]}
                        alt=""
                        width="24"
                        height="24"
                      />
                      <Typography variant="menuText">{Language}</Typography>
                    </MenuItem>
                  ))}
                </Menu>

                <IconButton onClick={handleOpenLanguageMenu} aria-label="Change language">
                  <LanguageIcon
                    sx={{ color: (theme) => theme.palette.text.primary }}
                  />
                </IconButton>
              </div>

              <a href="#contact" className="contact-btn">
                {strings.menu.contact[languageState]}
              </a>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
    );
  }

  return (
    <Stack>
      <ResponsiveAppBar />
    </Stack>
  );
}
